var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"detail-field-catalog-section mb-4"},[_c('b-row',{staticClass:"detail-field-catalog-section-header tabHeader mb-2"},[_c('b-col',{staticClass:"font-weight-bold",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.title))])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }